import React from 'react';
import { Col, Row } from '@gjensidige/core-grid';
import { useCmsContext } from '@gjensidige/service-cms';

import { CheckListItems } from '../../types';
import { Step } from '../../types/enums';
import { getLatestStepToGoToFromAnswers } from '../../utils';
import { useCheckListContext } from '../../context/CheckListProvider';
import Checkmark from './Checkmark';
import styles from './StepsDesktop.module.scss';

interface StepsDesktopProps {
  checkList: CheckListItems;
  children: React.ReactNode;
  onNavigationClick: (step: Step) => void;
}

const StepsDesktop = ({
  checkList,
  children,
  onNavigationClick
}: StepsDesktopProps) => {
  const { getText } = useCmsContext();
  const { currentStep, answers } = useCheckListContext();
  const latestStepToGo = getLatestStepToGoToFromAnswers(answers);

  return (
    <Row>
      <Col md={{ offset: 1, span: 8 }}>
        <Row>
          <Col md={5} xl={4}>
            <ul className={styles.list}>
              {Object.keys(checkList)
                .map((k) => parseInt(k, 10))
                .map((key) => {
                  return (
                    <li
                      className={`${key === currentStep ? styles.active : ''} ${
                        key > latestStepToGo && styles.disabled
                      }`}
                      key={key}
                      onClick={() => onNavigationClick(key)}
                    >
                      <Checkmark
                        value={answers[key as Step]}
                        className={styles.stepIcon}
                      />
                      {getText(`${checkList[key].texts}.modal.title`)}
                    </li>
                  );
                })}
            </ul>
          </Col>
          <Col>{children}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default StepsDesktop;
